import React, { useContext, useMemo } from "react"
import Tariff from "." // твой существующий компонент карточки
import { PriceContext } from "../../PriceContext"
import { TariffByKeyProps, TariffKey, TariffText } from "./types"

/**
 * Сопоставляет ключ тарифа к индексу в text.tariff.
 * Если у тебя другой порядок — поправь индексы тут, а не по всему коду.
 */
const TARIFF_INDEX: Record<TariffKey, number> = {
  Core: 0,
  Support: 1,
  Marketing: 2,
  MarketingExpert: 3,
  EnterpriseMarketing: 4,
  EnterpriseSupport: 5,
}

export default function TariffByKey({ tariffKey, overrides, buttons = true, show = true, Logo }: TariffByKeyProps) {
  const { text } = useContext(PriceContext)

  // достаём базовый текст из локализации (text.tariff[idx])
  const baseText: TariffText | null = useMemo(() => {
    if (!text?.tariff) return null
    const idx = TARIFF_INDEX[tariffKey]
    const t = text.tariff[idx]
    if (!t) return null
    // аккуратно нормализуем, чтобы точно были поля
    return {
      name: t.name ?? tariffKey,
      work: t.work ?? "",
      buttonClickEventText: t.buttonClickEventText ?? "",
      title: t.title ?? t.name ?? "",
      options: Array.isArray(t.options) ? t.options : [],
    }
  }, [text, tariffKey])

  // применяем overrides точечно (не мешая неизменённые поля)
  const merged: TariffText | null = useMemo(() => {
    if (!baseText) return null
    return {
      ...baseText,
      ...(overrides ?? {}),
      options: overrides?.options ?? baseText.options,
    }
  }, [baseText, overrides])

  if (!merged) return null

  return <Tariff text={merged} buttons={buttons} show={show} />
}
